import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {ReviewsErrorsFactory} from '../Errors/factory.js'
import {ReviewsMappersFactory} from '../Mappers/factory.js'
import {ReviewsValueObjectsFactory} from '../ValueObjects/factory'
import {HttpCommentsRepository} from './HttpCommentsRepository.js'
import {HttpRatingRepository} from './HttpRatingRepository'

export class ReviewsRepositoriesFactory {
  static httpCommentsRepository = ({config}) =>
    new HttpCommentsRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      fromGetCommentsResponseToCommentEntityMapper:
        ReviewsMappersFactory.fromCommentsListResponseToCommentListVOMapper(),
      fromPostResponseToCommentIdEntityMapper: ReviewsMappersFactory.fromPostResponseToCommentIdEntityMapper(),
      getCommentsError: ReviewsErrorsFactory.getCommentsError,
      postCommentError: ReviewsErrorsFactory.postCommentsError
    })

  static httpRatingRepository = ({config}) =>
    new HttpRatingRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      ratingValueObjectFactory: ReviewsValueObjectsFactory.newsRatingValueObject,
      ratingError: ReviewsErrorsFactory.ratingError
    })
}
